import type { CaseErrorsActions } from "@/hooks/cases/useCaseErrors.types";
import { useAPI } from "@/hooks/useAPI";
import { updateCaseInCache } from "@/hooks/useCases";
import { CaseErrorsService } from "@/services/cases/caseErrorsService";
import { useCallback, useMemo } from "react";

export const useCaseErrors = (): CaseErrorsActions => {
  const apiV1 = useAPI("v1");
  const caseErrorsService = useMemo(() => new CaseErrorsService(apiV1), [apiV1]);

  const resolveAllCaseErrors = useCallback(
    async (caseId: string): Promise<void> => {
      await caseErrorsService.resolveAll(caseId);
      updateCaseInCache(caseId, { unresolved_errors: [] });
    },
    [caseErrorsService]
  );

  return { resolveAllCaseErrors };
};
